export class UrlConst {
    public static LOGIN = "/login";
    public static HOME = "main/home/index";
    public static ACCOUNT = "main/account";   
}